<template>
  <admin-layout
    :table-headers="headers"
    :table-items="departments"
    :edit-item="editDepartment"
    :delete-item="deleteDepartment"
    :search="search"
  >
    <template v-slot:header>
      <!-- alert -->
      <snackbar ref="alert" class="mb-5"></snackbar>
      <!--/alert-->

      <header-section
        header-title="Departments"
        v-model="search"
        :add-new-item="addDepartment"
      >
        <template v-slot:addNew>
          <v-btn
            block
            color="primary"
            @click.stop="addDepartment"
            :disabled="dialog"
            >Add New</v-btn
          >

          <v-dialog
            v-model="dialog"
            max-width="400px"
            v-if="addDepartment"
            content-class="dialog-modal"
          >
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-form ref="form" v-model="validForm" lazy-validation>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          v-model="selectedDepartment.name"
                          :rules="formValidationRules"
                          label="Name*"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </header-section>
    </template>
  </admin-layout>
</template>

<script>
/* eslint no-useless-escape: 0 */ // --> OFF
import { mapActions, mapMutations } from "vuex";
import AdminLayout from "@/layouts/AdminLayout.vue";
import HeaderSection from "@/components/HeaderSection.vue";
import Snackbar from "@/components/Snackbar.vue";

export default {
  components: {
    AdminLayout,
    Snackbar,
    HeaderSection
  },
  data: () => ({
    validForm: true,
    dialog: false,
    search: "",
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Slug", value: "slug", align: "left" },
      { text: "Created", value: "created_on", align: "left" },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ],
    formValidationRules: [v => !!v || "This field is required"],
    selectedDepartment: {},
    formTitle: "Add New Department",
    inEditMode: false,
    unsubscribeFromStoreAlerts: undefined
  }),
  computed: {
    departments() {
      return Object.values(this.$store.state.departments);
    }
  },
  methods: {
    ...mapActions([
      "retrieveDepartmentsFromServer",
      "createDepartment",
      "updateDepartment",
      "destroyDepartment"
    ]),
    ...mapMutations(["showLoading", "hideLoading"]),
    isFormValid() {
      return this.$refs.form.validate();
    },
    resetValidation() {
      return this.$refs.form.resetValidation();
    },
    addDepartment() {
      this.close();
      this.selectedDepartment = {};
      this.openModal();
    },
    openModal() {
      this.dialog = true;
    },
    editDepartment(department) {
      this.close();
      // this.resetValidation();
      this.selectedDepartment = department;
      this.inEditMode = true;
      this.formTitle = "Edit Department";
      this.openModal();
    },
    async deleteDepartment(department) {
      this.$root
        .$confirm(
          "Delete Department",
          `Are you sure you wish the '${department.name}' department gone?`,
          {
            color: "red"
          }
        )
        .then(confirm => {
          if (confirm) {
            this.showLoading();
            this.destroyDepartment(department);
            this.hideLoading();
          }
        });
    },
    customAlert(type, message) {
      this.$refs.alert.open(type, message);
    },
    close() {
      this.dialog = false;
      this.selectedLink = {};
      this.inEditMode = false;
      this.formTitle = "Add New Department";
      this.resetValidation();
    },
    async save() {
      if (this.isFormValid()) {
        this.selectedDepartment.slug = this.slugify(
          this.selectedDepartment.name
        );
        const newDepartment = Object.assign({}, this.selectedDepartment);
        if (this.inEditMode) {
          this.showLoading();
          await this.updateDepartment(newDepartment);
          this.hideLoading();
        } else {
          this.showLoading();
          await this.createDepartment(newDepartment);
          this.hideLoading();
        }
        this.close();
      }
    },
    slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/[^\w\-]+/g, "") // Remove all non-word chars
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text
    }
  },
  created() {
    // subcribe to alert mutation
    this.unsubscribeFromStoreAlerts = this.$store.subscribe(
      (mutation, state) => {
        if (mutation.type == "updateAlert") {
          this.customAlert(state.alert.status, state.alert.message);
        }
      }
    );
  },
  destroyed() {
    // unsubscribe from alert mutation
    this.unsubscribeFromStoreAlerts();
  },
  async mounted() {
    this.showLoading();
    await this.retrieveDepartmentsFromServer();
    this.hideLoading();
  }
};
</script>
